class AxReassurance extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-ax-reassurance-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-ax-reassurance-dot]'));

    if (this.slides.length === 0) return;

    this.index = 0;
    this.interval = parseInt(this.getAttribute('autoplay'), 10) || 0;
    this.hovered = false;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.timer = null;
    this.controller = new AbortController();

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.select(i, true));
    });

    this.addEventListener('pointerenter', () => {
      this.hovered = true;
      this.updatePlayback();
    });
    this.addEventListener('pointerleave', () => {
      this.hovered = false;
      this.updatePlayback();
    });

    this.setupTooltips();
    this.select(0);
    this.updatePlayback();
  }

  disconnectedCallback() {
    this.stopTimer();
    if (this.controller) this.controller.abort();
  }

  select(i, manual) {
    const count = this.slides.length;
    this.index = ((i % count) + count) % count;

    this.slides.forEach((slide, idx) => {
      const active = idx === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    this.dots.forEach((dot, idx) => {
      if (idx === this.index) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });

    this.closeTooltips();

    if (manual) {
      this.stopTimer();
      this.updatePlayback();
    }
  }

  next() {
    this.select(this.index + 1);
  }

  updatePlayback() {
    const canPlay =
      this.interval > 0 &&
      this.slides.length > 1 &&
      !this.reducedMotion &&
      !this.hovered &&
      !this.isTooltipOpen();

    if (canPlay) {
      this.startTimer();
    } else {
      this.stopTimer();
    }
  }

  startTimer() {
    if (this.timer) return;
    this.timer = setInterval(() => this.next(), this.interval);
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  isTooltipOpen() {
    return !!this.querySelector('.ax-reassurance__tooltip.is-open');
  }

  setupTooltips() {
    this.tooltips = Array.from(this.querySelectorAll('[data-ax-reassurance-info]'));

    this.tooltips.forEach((info) => {
      const trigger = info.querySelector('.ax-reassurance__info-trigger');
      const tip = info.querySelector('.ax-reassurance__tooltip');
      if (!trigger || !tip) return;

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const open = tip.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.updatePlayback();
      });
    });

    if (this.tooltips.length === 0) return;

    const { signal } = this.controller;

    document.addEventListener(
      'click',
      (event) => {
        if (!this.contains(event.target)) {
          this.closeTooltips();
          this.updatePlayback();
        }
      },
      { signal }
    );

    this.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Escape') {
          this.closeTooltips();
          this.updatePlayback();
        }
      },
      { signal }
    );
  }

  closeTooltips() {
    (this.tooltips || []).forEach((info) => {
      const trigger = info.querySelector('.ax-reassurance__info-trigger');
      const tip = info.querySelector('.ax-reassurance__tooltip');
      if (tip) tip.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }
}

if (!customElements.get('ax-reassurance')) {
  customElements.define('ax-reassurance', AxReassurance);
}
